import React, { useState, useContext, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FaTimes } from "react-icons/fa"
import NotificationCard from '../home/NotificationCard'
import { RemoveGroupPopupContext } from "../../App"
import { useNavigate } from 'react-router-dom'
import { Logout, EmptyLocalStorage, DeleteResource, DeleteGroup } from "../../services/auth/auth.services"
import { success, error } from "../../constants/msg";
import { ToastContainer } from "react-toastify";

const RemoveBoxPopup = ({ redirectStatus, count, setCount, deletedGroupData, setDeletedGroupData, setshowSelectedResource, selectedGroup, setSelectedGroup, mergeGroupAndBoxes, setMergeGroupAndBoxes }) => {
    const [handleRemoveGroupPopup, setHandleRemoveGroupPopup] = useContext(RemoveGroupPopupContext);
    const [isDisabled, setIsDisabled] = useState(false)
    const navigate = useNavigate()

    const deleteGroup = async () => {
        const { id, index } = selectedGroup
        setIsDisabled(true)

        try {
            let temp = [...mergeGroupAndBoxes]            
            const res = await DeleteGroup(id)
            temp.splice(index, 1)
            setMergeGroupAndBoxes(temp)
            success(res.data.message)
            setSelectedGroup({
                index: "",
                id: "",
                name: ""
            })
            setCount(count + 1)
            setshowSelectedResource(null)
            setHandleRemoveGroupPopup(false)
            setIsDisabled(false)
            if(redirectStatus){
                navigate("/sub-admin/add-group")
            }
        }
        catch (e) {
            error(e.response.data.message)
            setTimeout(() => {
                setIsDisabled(false)
            }, 1500)
        }
    }

    return (
        <div>
            <Modal
                className='logout-modal'
                show={handleRemoveGroupPopup}
                onHide={() => setHandleRemoveGroupPopup(false)}
                size="md"
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Body>
                    <div className="header">
                        <div onClick={() => setHandleRemoveGroupPopup(false)} className="fa-times"><FaTimes /></div>
                    </div>

                    <div className='content-container'>
                        <div className='text-center border-bottom py-4'>
                            <h6 className='p-0 m-0 '>Delete Group</h6>
                        </div>

                        <div className='p-5 text-center'>
                            <div>
                                <p>
                                    Deleting a group will move all boxes to the root layer
                                </p>
                            </div>

                            <div className='mt-5'>
                                <Button disabled={isDisabled} onClick={() => deleteGroup()} className="btn-common me-4">Delete</Button>
                                <Button onClick={() => setHandleRemoveGroupPopup(false)} className="btn-common no-bg">Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default RemoveBoxPopup